export default "__VITE_ASSET__D4bTz9mE__"